import { createAction, props } from '@ngrx/store';
import { AppStateFailure } from '@symphony-solo/shared/common-state/src';
import { FavoriteItems } from '../models';
import { ChooseLocation } from '@symphony-solo/domain/choose-location/src';
import { Voucher } from '@symphony-solo/domain/voucher/src';
import { Purses } from '@symphony-solo/domain/purses/src';








export enum FavouriteItemActionTypes {

  GetFavouriteItemAction = "[FavouriteItem] GetFavouriteItemAction",
  GetFavouriteItemSuccessAction = "[FavouriteItem] GetFavouriteItemSuccessAction",
  GetFavouriteItemErrorAction = "[FavouriteItem] GetFavouriteItemErrorAction",
  GetFavouriteLocationAction = "[FavouriteItem] GetFavouriteLocationAction",
  GetFavouriteLocationsSuccessAction = "[FavouriteItem] GetFavouriteLocationsSuccessAction",
  GetFavouriteLocationsErrorAction = "[FavouriteItem] GetFavouriteLocationsErrorAction",
  GetFavouriteVoucherAction = "[FavouriteItem] GetFavouriteVoucherAction",
  GetFavouriteVouchersSuccessAction = "[FavouriteItem] GetFavouriteVouchersSuccessAction",
  GetFavouriteVouchersErrorAction = "[FavouriteItem] GetFavouriteVouchersErrorAction",
  GetFavouriteWalletsAction = "[FavouriteItem] GetFavouriteWalletAction",
  GetFavouriteWalletsSuccessAction = "[FavouriteItem] GetFavouriteWalletsSuccessAction",
  GetFavouriteWalletsErrorAction = "[FavouriteItem] GetFavouriteWalletsErrorAction",
  AddFavouriteItemAction = "[FavouriteItem] AddFavouriteItemAction",
  AddFavouriteItemSuccessAction = "[FavouriteItem] AddFavouriteItemSuccessAction",
  AddFavouriteItemErrorAction = "[FavouriteItem] AddFavouriteItemErrorAction",
  RemoveFavouriteItemAction = "[FavouriteItem] RemoveFavouriteItemErrorAction",
  RemoveFavouriteItemSuccessAction = "[FavouriteItem] RemoveFavouriteItemSuccessAction",
  LimitReachedFavouriteItemAction = "[FavouriteItem] LimitReachedFavouriteItemAction",
  SetAccountID = "[FavouriteItem] SetAccountID",
  ClearFavoriteItemsAction = "[FavouriteItem] ClearFavoriteItemsAction",



  ClearStateAction = "[FavouriteItem] ClearStateAction",
}

// export const GetFavouriteItemAction = createAction(FavouriteItemActionTypes.GetFavouriteItemAction, props<{params: RequestFavouriteItemParams}>());
export const GetFavouriteItemSuccessAction = createAction(FavouriteItemActionTypes.GetFavouriteItemSuccessAction, props<{ favouriteItem: FavoriteItems }>());
export const GetFavouriteItemErrorAction = createAction(FavouriteItemActionTypes.GetFavouriteItemErrorAction, props<{ failure: AppStateFailure }>());
export const ClearStateAction = createAction(FavouriteItemActionTypes.ClearStateAction, props<{actionType: string}>());


export const GetFavouriteLocationsAction = createAction(FavouriteItemActionTypes.GetFavouriteLocationAction);
export const GetFavouriteLocationsSuccessAction = createAction(FavouriteItemActionTypes.GetFavouriteLocationsSuccessAction, props<{ locations: ChooseLocation[] }>());
export const GetFavouriteLocationsErrorAction = createAction(FavouriteItemActionTypes.GetFavouriteLocationsErrorAction, props<{ failure: AppStateFailure }>());
export const GetFavouriteVouchersAction = createAction(FavouriteItemActionTypes.GetFavouriteVoucherAction);
export const GetFavouriteVouchersSuccessAction = createAction(FavouriteItemActionTypes.GetFavouriteVouchersSuccessAction, props<{ vouchers: Voucher[] }>());
export const GetFavouriteVouchersErrorAction = createAction(FavouriteItemActionTypes.GetFavouriteVouchersErrorAction, props<{ failure: AppStateFailure }>());
export const GetFavouriteWalletsAction = createAction(FavouriteItemActionTypes.GetFavouriteWalletsAction);
export const GetFavouriteWalletsSuccessAction = createAction(FavouriteItemActionTypes.GetFavouriteWalletsSuccessAction, props<{ wallets: Purses[] }>());
export const GetFavouriteWalletsErrorAction = createAction(FavouriteItemActionTypes.GetFavouriteWalletsErrorAction, props<{ failure: AppStateFailure }>());
export const AddFavouriteItemAction = createAction(FavouriteItemActionTypes.AddFavouriteItemAction, props<{ itemType: string, item: any }>());
export const AddFavouriteItemSuccessAction = createAction(FavouriteItemActionTypes.AddFavouriteItemSuccessAction, props<{ itemType: string, updatedFavoriteItems: any[] }>());
export const AddFavouriteItemErrorAction = createAction(FavouriteItemActionTypes.AddFavouriteItemErrorAction, props<{ failure: string }>());
export const RemoveFavouriteItemAction = createAction(FavouriteItemActionTypes.RemoveFavouriteItemAction, props<{ itemType: string, itemId: number | string }>());
export const RemoveFavouriteItemSuccessAction = createAction(FavouriteItemActionTypes.RemoveFavouriteItemSuccessAction, props<{ itemType: string, updatedFavoriteItems: any[] }>());
export const LimitReachedFavouriteItemAction = createAction(FavouriteItemActionTypes.LimitReachedFavouriteItemAction, props<{ itemType: string }>());
export const ClearFavoriteItemsAction = createAction(FavouriteItemActionTypes.ClearFavoriteItemsAction);

export const setAccountID = createAction(FavouriteItemActionTypes.SetAccountID, props<{ accountID: number }>());